export default __webpack_public_path__ + "static/media/19.7602e043.jpg";